import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams, Res } from 'src/app/models';
import { LanguageService, NotificationService, ApiNotificationsService, ValidatorsService } from 'src/app/services';
import { NotificationsChannelsSettingsActionsValidator } from './notifications-channels-settings-actions.validator';

@Component({
  selector: 'app-notifications-channels-settings-actions',
  templateUrl: './notifications-channels-settings-actions.component.html',
  styleUrls: ['./notifications-channels-settings-actions.component.css']
})
export class NotificationsChannelsSettingsActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  notificationId: string;
  notificationData:any;
  language: string;
  loading: boolean;
  types: any[] = [];
  channels: any[] = [];
  errorMessages: any;

  form: UntypedFormGroup = this.fb.group({
    notifications: this.fb.array([])
  });

  @Input() set data(value) {

    if (value != null) {

      this.notificationId = value.notifications_id;

    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private apiNotifications: ApiNotificationsService,
    private notification: NotificationService,
    private validatorService: ValidatorsService,
    private validator: NotificationsChannelsSettingsActionsValidator,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.getNotificationTypes();
    this.getNotificationChannels();

    if (this.notificationId) {

      this.onEdit();
    } else {

      this.addNotificationField();
    }

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  /**
   * 
   * @param type string
   */
  initNotificationField(): any {

    return this.fb.group({
      id: [''],
      notification_type: [null, this.validator.notification_type],
      notification_channel: [null, this.validator.notification_channel],
      delivery_address: [null, this.validator.delivery_address]
    });
  }


  /**
   * 
   * @param type string
   */
  addNotificationField(): void {

    let control = this.form.controls.notifications as UntypedFormArray;
    control.push(this.initNotificationField());
  }


  /**
   * 
   * @param i number
   */
  removeNotificationField(i: number): void {

    let control = this.form.controls.notifications as UntypedFormArray;
    control.removeAt(i);
  }

  /**
   * 
   * @param address Address
   */
  setDataInNotificationField(notification: any): any {

    return this.fb.group({
      id: notification.id,
      notification_type: notification.notification_type,
      notification_channel: notification.notification_channel,
      delivery_address: notification.delivery_address
    });
  }


  /**
   * 
   * @param address Address
   */
  addNotificationFieldWithData(notification: any): void {

    let control = this.form.controls.notifications as UntypedFormArray;
    control.push(this.setDataInNotificationField(notification));
  }


  /**
  * 
  */
  getNotificationTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'notification_types',
      filter: {

      }
    }

    this.subscriptions.add(
      this.apiNotifications.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.types = response.result;

        }
      })
    );
  }

  /**
  * 
  */
  getNotificationChannels(): void {

    let params: ReferenceParams = {
      ref_name: 'notification_channels',
      filter: {

      }
    }

    this.subscriptions.add(
      this.apiNotifications.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.channels = response.result;
        }
      })
    );
  }

  /**
  * 
  */
  onCreate(): void {

    let form = { ...this.form.value }

    this.progressRef.start();

    console.log("FORM: ", form);


    this.subscriptions.add(
      this.apiNotifications.createNotificationsChannel(form).subscribe((response: Res) => {
        console.log('[RESPONSE] CREATE_CHANNEL: ', response);

        if (response != null) {

          this.notification.show('success', 'Настройки успешно сохранены!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiNotifications.editNotificationsChannel(this.notificationId).subscribe((response: Res) => {
        console.log('[RESPONSE] CHANNEL_EDIT: ', response);

        if (response != null) {

          this.notificationData = { ...response.result };

          this.addNotificationFieldWithData(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiNotifications.updateNotificationsChannel(form).subscribe((response: Res) => {
        console.log('[RESPONSE] UPDATE_CHANNEL: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /* VALIDATION */

  /**
   * 
   * @param field 
   * @param type 
   */
   validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

   /**
   * 
   * @param field 
   */
    checkingFieldStatus(field: string): string {

      return this.validatorService.checkingFieldStatus(this.form.get(field));
    }

}
